import type { ReorderedRouteType } from '../Planning/AssignmentApi';
import { RoutePointDeltaSchema } from '../../utilities/RoutePointsApi';

export class ReorderStackUtils {
    static sortDeltasByTime(reorder_stack: ReorderedRouteType): string[] {
        if (!reorder_stack.deltas) {
            console.warn('No deltas found in reorder_stack');
            return [];
        }
        return Object.entries(reorder_stack.deltas)
            .filter(([, value]) => value !== null)
            .sort(([, a], [, b]) => (b && a ? a.g.t - b.g.t : 0))
            .map(([key, value]) => key);
    }
}
